import Image from './dom';
export default Image;
